import { staffApis } from '@apis/dashboard/staffApis';
import { useQuery } from '@hooks/useQuery';

export const useStaff = (id?: number) => {
  return useQuery([`/dashboard/staff/${id}/`], () =>
    id !== undefined
      ? staffApis.get('/dashboard/staff/{id}/', { path: { id } }).then((r) => r['200']!)
      : undefined,
  );
};
